import { Checkbox, Popover, Skeleton } from "@vkontakte/vkui";
import s from "./style.module.scss";
import { Icon16HelpOutline } from "@vkontakte/icons";
import { useAction, useAtom } from "@reatom/npm-react";
import {
  currentServiceAtom,
  currentServiceCalculateAction,
  currentServiceIsLoadingAtom,
  extraAtom,
} from "../../core/reatom/state/currentService/currentService";
export const AdditionalOptions = () => {
  const [currentService] = useAtom(currentServiceAtom);
  const summaryPrice = useAction(currentServiceCalculateAction);
  const [isLoadingAtom] = useAtom(currentServiceIsLoadingAtom);
  const handleSummary = (extra: number[]) => {
    summaryPrice(`${currentService?.id}`, extra);
  };

  return (
    <div className={s.wrapper}>
      {isLoadingAtom ? (
        <>
          <Skeleton className={s.wrapper} height={60} />
        </>
      ) : (
        <>
          <p className={s.title}>Дополнительные опции</p>
          {currentService?.extra.map((options) => (
            <AdditionalCheckbox
              index={options.id}
              handleSummary={handleSummary}
              key={options.id}
              description={`${options.price_emp.toLocaleString("ru-RU")} ₽`}
              title={options.title}
              helperText={options.result}
              days={options.days}
            />
          ))}
        </>
      )}
    </div>
  );
};

interface AdditionalCheckboxProps {
  description: string;
  title: string;
  helperText: string;
  days: string;
  index: number;
  handleSummary: (extra: number[]) => void;
}

export const AdditionalCheckbox = (props: AdditionalCheckboxProps) => {
  const { description, title, helperText, days, index, handleSummary } = props;
  const [extra, setExtra] = useAtom(extraAtom);

  const handleCheckboxChange = (checked: boolean) => {
    const extra = setExtra((prev) =>
      checked ? [...prev, index] : prev.filter((i) => i !== index)
    );
    handleSummary(extra);
  };

  return (
    <>
      <Checkbox
        className={s.checkbox}
        style={{ padding: 0 }}
        checked={extra.includes(index)}
        onChange={(e) => handleCheckboxChange(e.target.checked)}
      >
        <div className={s.checkboxWrapper}>
          <div>
            <p className={s.titleCheckbox}>{title}</p>
            <p className={s.description}>{description}</p>
          </div>
          <Popover
            trigger="hover"
            placement="top"
            role="tooltip"
            aria-describedby="tooltip-1"
            content={
              <div className={s.helperTextWrapper}>
                <p className={s.days}>+ {days} дней</p>
                <p className={s.helperText}>{helperText}</p>
              </div>
            }
            restoreFocus="anchor-element"
            arrow
          >
            <button id="tooltip-1" className={s.button}>
              <Icon16HelpOutline className={s.icons} />
            </button>
          </Popover>
        </div>
      </Checkbox>
    </>
  );
};
